export default "__VITE_ASSET__DBOxW0BD__"